import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";

const AdditionalServices = () => {
  const [index, setIndex] = useState(0);
  const [services, setServices] = useState([]);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    const fetchAdditionalServices = async () => {
      try {
        const response = await fetch(
          "https://eventscons.com/eventbackendnew/api/additional-service-list"
        );
        const result = await response.json();

        if (result?.status && Array.isArray(result?.data)) {
          setServices(result.data);
        }
      } catch (error) {
        console.error("Additional services API fetch error:", error);
      }
    };

    fetchAdditionalServices();
  }, []);

  // Array ko 4-4 ke chunks me todhna
  const chunkServices = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const serviceChunks = chunkServices(services, 4); // har slide me 4 boxes

  const ServiceBox = ({ service, idx }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div className="col-lg-3 col-md-6" style={{ display: "flex" }}>
        <div
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            backgroundColor: isHovered ? "#000" : "#f8f8f8",
            color: isHovered ? "#fff" : "#000",
            padding: "60px 35px",
            width: "100%",
            textAlign: "left",
            borderRight: idx !== 3 ? "1px solid #e5e5e5" : "none",
            transition: "all 0.4s ease",
            cursor: "pointer",
          }}
        >
          <div style={{ marginBottom: "25px" }}>
            <img
              src={service.image}
              alt={service.heading}
              style={{
                width: "50px",
                height: "50px",
                objectFit: "contain",
                filter: isHovered ? "brightness(0) invert(1)" : "none",
                transition: "0.4s ease",
              }}
            />
          </div>
          <h3 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "15px" }}>
            {service.heading}
          </h3>
          <p
            style={{
              fontSize: "14px",
              opacity: isHovered ? 0.9 : 0.7,
              lineHeight: "1.5",
              color: isHovered ? "#fff" : "#000",
            }}
          >
            {service.text}
          </p>
        </div>
      </div>
    );
  };

  return (
    <section
      className="additional-services"
      style={{ paddingTop: "80px",paddingBottom: "20px", backgroundColor: "#fff", textAlign: "center" }}
    >
      <div className="auto-container">
        <div className="sec-title mb-5">
          <h6
            style={{
              color: "#b21e35",
              fontWeight: "400",
              fontSize: "18px",
            }}
          >
            Additional Services
          </h6>
          <h2 className="mainheadingfont mainheadinghome"
            style={{
              fontSize: "42px",
              fontWeight: "600",
              marginTop: "10px",
              color: "#000",
              textAlign:'center',
            }}
          >
            Post-Event Wrap-Up And <br /> Performance Insights
          </h2>
        </div>

        {serviceChunks.length > 0 ? (
          <>
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              indicators={false}
              controls={false}
              interval={null} // manual dots only
            >
              {serviceChunks.map((chunk, slideIdx) => (
                <Carousel.Item key={slideIdx}>
                  <div className="row g-0">
                    {chunk.map((service, idx) => (
                      <ServiceBox key={service.id} service={service} idx={idx} />
                    ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>

            {/* Custom indicators = slide count ke hisaab se dots */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "50px",
                gap: "8px",
              }}
            >
              {serviceChunks.map((_, dot) => (
                <div
                  key={dot}
                  onClick={() => handleSelect(dot)}
                  style={{
                    width: "70px",
                    height: "5px",
                    backgroundColor: index === dot ? "#000" : "#e0e0e0",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                  }}
                />
              ))}
            </div>
          </>
        ) : (
          <p>Loading...</p>
        )}
      </div>

      {/* <div
        style={{
          height: "12px",
          backgroundColor: "#000",
          marginTop: "60px",
        }}
      ></div> */}
    </section>
  );
};

export default AdditionalServices;